import { render, staticRenderFns } from "./NewsPost3.vue?vue&type=template&id=2a56e37d&"
import script from "./NewsPost3.vue?vue&type=script&lang=ts&"
export * from "./NewsPost3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports